'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('createMemoryHistory');
module.exports = require('./index.js').createMemoryHistory;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/history/createMemoryHistory.js
// module id = 926
// module chunks = 0